export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_appName') || '应用名称',
    field: 'amzAppName',
    minWidth: 130,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amzStoreNo') || '店铺编号',
    field: 'amzStoreNo',
    minWidth: 130,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_amzStoreName') || '店铺名称',
    field: 'amzStoreName',
    minWidth: 160,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_marketplaceId') || '亚马逊商城ID',
    field: 'marketplaceId',
    minWidth: 160,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_taskType') || '报表任务类型',
    field: 'taskType',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_reportType') || '报表类型',
    field: 'reportType',
    minWidth: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_dataStartTime') || '报告数据的开始时间',
    field: 'dataStartTime',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_dataEndTime') || '报告数据的结束时间',
    field: 'dataEndTime',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_reportId') || '亚马逊报表ID',
    field: 'reportId',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title:
      that.$l('table_label_reportProcessingStatus') || '亚马逊报表当前处理状态',
    field: 'reportProcessingStatus',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_reportProcessed') || '报表是否处理结束',
    field: 'reportProcessed',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'reportProcessed' },
  },
  {
    title: that.$l('table_label_documentId') || '亚马逊文档ID',
    field: 'documentId',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'document' },
  },
  {
    title: that.$l('table_label_syncStatus') || '同步到系统的状态',
    field: 'syncStatus',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'syncStatus' },
  },
  {
    title: that.$l('table_label_syncOssFile') || 'OSS同步文件',
    field: 'syncOssFileName',
    minWidth: 130,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'syncOssFile' },
  },
  {
    title: that.$l('table_label_createTime') || '创建时间',
    field: 'createTime',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_modifyTime') || '更新时间',
    field: 'modifyTime',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
]
